export enum ModalTypes {
  NONE,
  INFO,
  ALERT,
  ERROR,
  REJECT,
  SUCCESS,
  CUSTOM,
  APPROVE,
  WARNING
}
